import { reportAuthSessionLost } from './authSession';

/** Must match keys used in AuthContext (login/logout). */
export const AUTH_TOKEN_STORAGE_KEY = 'groverSweets_token';

/**
 * Grover API expects the JWT on this header (lowercase), not `Authorization: Bearer`.
 * @see Postman: `token: eyJ...`
 */
export const AUTH_API_TOKEN_HEADER = 'token';

/** In-memory copy so the first requests after login see a token even if anything reads before LS is visible. */
let sessionAuthToken = null;

export function setSessionAuthToken(token) {
  sessionAuthToken =
    token != null && String(token).trim() ? String(token).trim() : null;
}

export function clearSessionAuthToken() {
  sessionAuthToken = null;
}

export function getStoredAuthToken() {
  if (sessionAuthToken) return sessionAuthToken;
  if (typeof localStorage === 'undefined') return null;
  const t = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  return t && String(t).trim() ? String(t).trim() : null;
}

/** JWT only (no `Bearer ` prefix) for the `token` header. */
export function getRawJwtForApi() {
  const raw = getStoredAuthToken();
  if (!raw) return null;
  return raw.replace(/^Bearer\s+/i, '').trim() || null;
}

/**
 * @param {Headers} headers
 * @returns {Headers}
 */
export function applyAuthTokenToHeaders(headers) {
  const jwt = getRawJwtForApi();
  if (jwt && !headers.has(AUTH_API_TOKEN_HEADER)) {
    headers.set(AUTH_API_TOKEN_HEADER, jwt);
  }
  return headers;
}

/**
 * Same as fetch, but sets the API `token` header when a stored JWT exists.
 * An explicit `token` header in init is left unchanged.
 */
export async function authFetch(input, init = {}) {
  const nextInit = { ...init };
  const headers = new Headers(init.headers);
  applyAuthTokenToHeaders(headers);
  nextInit.headers = headers;
  const res = await fetch(input, nextInit);
  if (res.status === 401 || res.status === 403) {
    reportAuthSessionLost();
  }
  return res;
}
